import { useEffect } from 'react'
import config from '@/config'
import * as actions from '@actions'
import * as store from '@store'
import { CHECK_REPORT_STATUS_CREATED, CHECK_REPORT_STATUS_FAILED } from '@constants'
import { useWireValue } from '@forminator/react-wire'

const usePollCheckReportStatus = (reports, callback) => {
    const remoteConfig = useWireValue(store.remoteConfig)
    
    useEffect(() => {
        
        if (remoteConfig?.realtimeEnabled) return
        if (!reports?.length) return
        
        const checkCheckReportStatus = async () => {
            
            try {
                
                const res = await actions.checkReportStatuses(reports.map(it => it.id))
                
                const readyOrFailed = res.filter(it => [
                    CHECK_REPORT_STATUS_CREATED,
                    CHECK_REPORT_STATUS_FAILED,
                ].includes(it.status))
                
                if (readyOrFailed.length)
                    callback(null, readyOrFailed)
                
            } catch (e) {
                
                console.error('checkCheckReportStatus#checkCheckStatus failed', e)
                callback(e)
                
            }
            
        }
        
        const t = setInterval(checkCheckReportStatus, config.checkStatusPollInterval)
        
        return () => clearInterval(t)
        
    }, [reports])
    
}

export default usePollCheckReportStatus
